export default {
  name: "Yuridik shaxs nomi",
  entity: "Yuridik shaxs",
  iik: "IIK",
  inn: "INN",
  bin: "BIN",
  bic: "BIC",
  bankBic: "Bank BIC",
  bankMFO: "MMT Banki",
  codeFiscal: "Fiskal kod",
  head_name_description:
    "Avtomatik tarzda aktlar va hisoblar yaratiladigan mas’ul shaxsning F.I.Sh. kiriting",
  mainOrganization: "Asosiy yuridik shaxs",
  mainOrganizationHint:
    "Asosiy yuridik shaxs tarif sotib olish uchun ishlatiladi va uning amal qilish muddati tugagandan keyin ham faol qoladi. Asosiy yuridik shaxsni o‘zgartirish 14 kunda bir martadan ko‘p bo‘lmasligi mumkin",
  chooseMainOrganization: "Yuridik shaxsni tanlang",
  maxOrganizationError: "Maksimal yuridik shaxslar soni yaratilgan",
  moderOrganizationError:
    "Yangi yuridik shaxs qo‘sholmaysiz, chunki moderatsiya jarayoni davom etmoqda",
  aboutTitle: "Sizning yuridik shaxsingiz haqida ma’lumot",
  typeOrganization: "Tashkilot turi",
  bankName: "Bank nomi",
  legalAddress: "Yuridik manzil",
  currentAccountNumber: "Hisob raqami",
  correspondentAccount: "Korschet",
  vatCode: "QQS kodi",
  addressFieldRequired: "Yuridik manzil kiritilmagan",
  metaIsRequired: "Bank ma’lumotlari kiritilmagan",
  add: {
    button: "Yuridik shaxs yaratish",
  },
  registrationNumber: "Ro'yxatdan o'tish raqami",
  entities: "Yuridik shaxslar",
  head_name: "Rahbarning F.I.Sh.",
  ogrn: "OGRN",
  ogrnOgrnip: "OGRN / OGRNIP",
  legalTypes: "Yuridik shakl",
  taxSystem: "Soliq tizimi",
  monthlyTurnover: "Oylik aylanma",
  depositSum: "Depozit summasi",
  okvedLabel: "Asosiy faoliyat turi",
  legalEntityCharter: "Yuridik shaxs ustavi",
  mainEntity: "Asosiy",
  mainEntityInfo: [
    "Asosiy yuridik shaxs tarif sotib olish uchun ishlatiladi va uning amal qilish muddati tugagandan keyin yangi tarif to‘lanmasa ham faol qoladi.",
    "Asosiy yuridik shaxsni 14 kunda bir martadan ko‘p o‘zgartirish mumkin emas.",
  ],
  cantCreateModal: {
    title: "Siz tarif bo‘yicha maksimal yuridik shaxslarni yaratdingiz",
  },
  deposit: "Depozit",
  enterInnOrEntityName: "INN yoki yuridik shaxs nomini kiriting",
  entityCreating: "Yuridik shaxs yaratilmoqda",
  updateEntityNotifyMessage: {
    create: "Yuridik shaxs moderatsiyaga yuborildi",
    edit: "Yuridik shaxs ma’lumotlari muvaffaqiyatli o‘zgartirildi",
  },
  commercial: "Tijorat yuridik shaxs",
  uncommercial: "Notijorat yuridik shaxs",
  depositMinSumHint:
    "Hisobdagi minimal qoldiq. Pul yechishda balansda qoladigan summa kamida {minDeposit} RC.",
  entityType: "Yuridik shaxs turi",
  entityInfo: "Yuridik shaxs haqida ma’lumot",
  bankDetails: "Bank rekvizitlari",
  frequencyMainEntityChanging:
    "Asosiy yuridik shaxsni 14 kunda bir martadan ko‘p o‘zgartirib bo‘lmaydi.",
  abailableChangeMainEntity:
    "Asosiy yuridik shaxsni o‘zgartirish {nextChangeDate} dan mavjud bo‘ladi.",
  mainEntityDescription:
    "Tarif sotib olish uchun ishlatiladi va uning amal qilish muddati tugagandan keyin yangi tarif to‘lanmasa ham faol qoladi.",
  entityHasHalal: "Yuridik shaxs Halol sertifikatiga ega",
  headNameToSendActs:
    "Avtomatik tarzda aktlar va hisoblar yaratiladigan mas’ul shaxsning F.I.Sh.",
  certHalal: "Halol sertifikati",
  makeMainEntity: "{entityName}ni asosiy yuridik shaxs qilish?",
  successChangedMainEntity: "Asosiy yuridik shaxs muvaffaqiyatli o‘zgartirildi",
  mainEntityUseForBuyingTariff:
    "Asosiy yuridik shaxs tarif sotib olish uchun ishlatiladi va uning amal qilish muddati tugagandan keyin yangi tarif to‘lanmasa ham faol qoladi.",
  afterConfirmYouCanChangeMainEntityIn14Days:
    "«Tasdiqlash» tugmasini bosganingizdan so‘ng, asosiy yuridik shaxsni 14 kundan keyin yana o‘zgartirish mumkin bo‘ladi.",
  cancelCreationModal: {
    title: "Yuridik shaxs yaratishni bekor qilmoqchimisiz?",
    subtitle:
      "Kiritilgan ma’lumotlar saqlanmaydi. Yuridik shaxs yaratishni davom ettirish uchun «Orqaga» tugmasini bosing.",
  },
  pressBackToSave:
    "O‘zgartirishlarni saqlash yoki tahrirlashni davom ettirish uchun «Orqaga» tugmasini bosing.",
  congratulateWithCreateEntity: "Yuridik shaxs yaratish bilan tabriklaymiz!",
  entityInModerationNow:
    "Hozirda sizning yuridik shaxsingiz tekshiruvdan o‘tayapti. Jarayon 24–48 soat davom etadi.",
  toPassModerationPayBill:
    "Tekshiruvdan o‘tish uchun, pastdagi tugma orqali hisobni to‘lab, moderatsiyani yakunlang. Hisobni shuningdek, shaxsiy kabinetda: «Mening korxonalarim» - «Hujjatlar» bo‘limida «Test to‘lovi» nomi bilan topishingiz mumkin.",
  entityEditingNotAvailabel: "Yuridik shaxsni tahrirlash vaqtincha mavjud emas",
  cashPaymentBeingMade:
    "Naqd pul to‘lovlari amalga oshirilmoqda. Shu davrda yuridik shaxs ma’lumotlarini tahrirlash mumkin emas.",
  entityHasPointsWithConnectPaymentMethods:
    "Yuridik shaxsda to‘lov usullari ulangan savdo nuqtalari mavjud",
  detailsChangesAvailableOnlyIntoTechHelp:
    "To‘lov usullari ulangan holatda yuridik shaxs rekvizitlarini o‘zgartirish faqat texnik yordam orqali mumkin <a href='mailto:hello@rc.city'>hello@rc.city</a>",
  forChangeBankDetailsTellUs:
    "Diqqat: to‘lov usullaridagi bank rekvizitlarini o‘zgartirish uchun qo‘shimcha ravishda bizga xabar bering.",
  uCanChangeOnlyDepositSum:
    "Siz faqat depozit summasini mustaqil o‘zgartirishingiz mumkin, buning uchun «Tahrirlash» tugmasini bosing.",
};
